

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"15","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n  ", h('circle', {"cx":"7.5","cy":"7","r":"7","fill":"#08856C"}, []), "\n  ", h('path', {"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.803 4.23a.583.583 0 0 1 .051.823L6.976 9.45a.875.875 0 0 1-1.361-.06L4.113 7.345a.583.583 0 1 1 .94-.69l1.104 1.5a.25.25 0 0 0 .389.017l3.433-3.892a.583.583 0 0 1 .824-.051Z","fill":"#fff"}, []), "\n"]);
};

        